import React from 'react';
import { Box, Paper, styled } from '@mui/material';
import { LIMITATIONS_DISCLOSURES_HTML } from '../constants/limitations';

const StyledPaper = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(4),
  margin: theme.spacing(2),
  minHeight: '842px', // A4 height
  width: '595px', // A4 width
  backgroundColor: '#fff',
  fontSize: '12px',
  lineHeight: 1.4,
  '& .MuiTypography-root': {
    fontSize: '12px',
    lineHeight: 1.4,
  },
  '& p': {
    margin: '1em 0',
    textAlign: 'justify',
  },
}));

const LimitationsDisclosuresPreview: React.FC = () => {
  return (
    <StyledPaper elevation={2}>
      <style>{`
        .limitations-content {
          font-family: Times New Roman, serif;
          font-size: 12px;
          line-height: 1.4;
        }
        .limitations-content p {
          margin: 2em 0;
          text-align: justify;
        }
        .limitations-content h2 {
          color: #1976d2;
          font-weight: bold;
          text-decoration: underline;
          margin-bottom: 1rem;
          font-size: 14px;
        }
      `}</style>
      <Box className='limitations-content'>
        <div dangerouslySetInnerHTML={{ __html: LIMITATIONS_DISCLOSURES_HTML }} />
      </Box>
    </StyledPaper>
  );
};

export default LimitationsDisclosuresPreview;
